import { ChangeEvent } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import ButtonWrapper from "../../StylesWrappers/General/button";
import InputWrapper from "../../StylesWrappers/General/inputBox";
import Button from "../../components/General/Button";
import InputBox from "../../components/General/InputBox";
import SelectOption from "../../components/General/SelectOption";
import { AppDispatch, RootState } from "../../store";
import {
  clearInput,
  submitData,
  updateData,
  collectInput,
} from "../../features/addJob/addJobSlice";
import AddJobAllJobsProfile from "../../StylesWrappers/General/AddJobAllJobsProfile";
import TitleText from "../../components/General/Helmet";
import TextArea from "../../components/General/textArea";
import Overlay from "../../components/General/overlay";
import Loader from "../../components/General/Loader";
import { toastMessage } from "../../utils/toastMessage";

const AddJobs = () => {
  const { inputs, jobLoading, jobDisable } = useSelector(
    (store: RootState) => store.addJobStore
  );
  const { btnContent } = useSelector((store: RootState) => store.editJobStore);

  const { position, company, jobLocation, jobStatus, jobDescription, jobType } =
    inputs;

  const dispatch = useDispatch<AppDispatch>();

  // Handle input change
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let name = e.target.name;
    let value = e.target.value;

    dispatch(collectInput({ name, value }));
  };

  // Handle Select change
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let name = e.target.name;
    let value = e.target.value;

    dispatch(collectInput({ name, value }));
  };

  // Submit all inputs
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!position || !company || !jobLocation || !jobDescription) {
      toastMessage("No field should be empty", dispatch, toast.error);
      return;
    }
    if (!jobStatus) {
      toastMessage(
        "Please, select a value for job status",
        dispatch,
        toast.error
      );
      return;
    }
    if (!jobType) {
      toastMessage(
        "Please, select a value for job type",
        dispatch,
        toast.error
      );
      return;
    }

    if (btnContent === "Submit") {
      await dispatch(submitData(inputs));
    } else {
      const id = inputs._id;
      dispatch(updateData({ inputs, id, dispatch }));
    }
  };

  // Reset initial inputs
  const handleReset = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearInput());
  };

  return (
    <>
      {jobLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <AddJobAllJobsProfile>
        <TitleText title="Jobtrackier - Add Jobs" />
        <p className="page__title">
          {btnContent === "Submit" ? "Add Job" : "Update Job"}{" "}
        </p>
        {btnContent === "Submit" && (
          <p className="page__intro">
            Manually add job you have applied for here
          </p>
        )}
        <InputWrapper>
          <div className="role__one">
            <InputBox
              jobName="Position"
              typeName="text"
              inputName="position"
              placeholder="Add the position you're applying for"
              inputValue={position}
              handleChange={handleChange}
            />
            <InputBox
              jobName="Company"
              typeName="text"
              inputName="company"
              placeholder="Add name of company"
              inputValue={company}
              handleChange={handleChange}
            />
            <InputBox
              jobName="Job Location"
              typeName="text"
              inputName="jobLocation"
              placeholder="Add company's location"
              inputValue={jobLocation}
              handleChange={handleChange}
            />
          </div>

          <TextArea
            name={"jobDescription"}
            value={jobDescription}
            label={"Job Description and other requirements"}
            placeholder={"Add a brief job description and other requirements"}
            cols={12}
            rows={10}
            handleChange={handleChange}
          />

          <div className="last__role">
            <SelectOption
              statusName="jobStatus"
              statusValue={jobStatus}
              selectName="Status"
              optionOne="Pending"
              optionTwo="Interview"
              optionThree="Declined"
              valueOne="pending"
              valueTwo="interview"
              valueThree="declined"
              handleSelect={handleSelect}
            />
            <SelectOption
              statusName="jobType"
              statusValue={jobType}
              selectName="Job Type"
              optionOne="Full-time (on-site)"
              optionTwo="Full-time (remote)"
              optionThree="Part-time (on-site)"
              optionFour="Part-time (remote)"
              optionFive="Internship (on-site)"
              optionSix="Internship (remote)"
              optionSeven="Contract (on-site)"
              optionEight="Contract (remote)"
              optionController="jobType"
              valueOne="full-time-onsite"
              valueTwo="full-time-remote"
              valueThree="part-time-onsite"
              valueFour="part-time-remote"
              valueFive="internship-onsite"
              valueSix="internship-remote"
              valueSeven="contract-onsite"
              valueEight="contract-remote"
              handleSelect={handleSelect}
            />

            <ButtonWrapper>
              {btnContent !== "Update" && (
                <Button
                  button="Clear"
                  type="reset"
                  handleSubmit={handleReset}
                  btnStyle={{
                    cursor: `${jobLoading ? "not-allowed" : ""}`,
                  }}
                />
              )}
              <Button
                button="Submit"
                handleSubmit={handleSubmit}
                type="submit"
                allLoading={jobLoading}
                allDisable={jobDisable}
                btnStyle={{
                  cursor: `${jobLoading ? "not-allowed" : ""}`,
                  width: `${btnContent === "Update" ? "100%" : "50%"}`,
                }}
              />
            </ButtonWrapper>
          </div>
        </InputWrapper>
      </AddJobAllJobsProfile>
    </>
  );
};

export default AddJobs;
